export default __webpack_public_path__ + "static/685-50610c40ca933904f16edd4bace629bb.gif";